import { useMemo } from "react";
import { bool, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { PriceFormats } from "@repo/utils";
import { MAX_VALUES } from "@utils";
import { ValueCell, useEstimateEditorSettings, useEstimateStructure, useEstimateTableSettings } from "@tools";
import { MaterialTitleCellEditor } from "./MaterialTitleCellEditor";

export const TaskUnitPriceCell = observer(({
  element,
  displayCellContent,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { currencyObj, priceFormat } = structure.settings;
  const { allowEdition } = useEstimateEditorSettings();
  const {
    materialsSection,
    sectionUnitPriceName,
    setSectionUnitPriceName,
    visibleWorkTypes,
    workTypeColumnsMaxState,
  } = useEstimateTableSettings();
  
  const { unitPrice, unitPriceName, parentHoldsMaterialPrice } = element;
  
  const size = useMemo(() => (
    visibleWorkTypes.length >= 2 && !materialsSection
      ? workTypeColumnsMaxState[visibleWorkTypes.slice(-2)[0].id] ? "medium" : "small"
      : "small"
  ), [ visibleWorkTypes, workTypeColumnsMaxState, materialsSection ]);
  
  const extendPadding = useMemo(() => (
    allowEdition && !materialsSection && visibleWorkTypes.length >= 2
  ), [ allowEdition, visibleWorkTypes, materialsSection ]);
  
  return <ValueCell
    size={size}
    value={unitPrice}
    emptyInputs={parentHoldsMaterialPrice}
    onValueChange={element.setUnitPrice}
    navigationKey="material-1"
    editable={allowEdition}
    extendPadding={extendPadding}
    displayContent={displayCellContent}
    visible
    showDecimals
    symbolStart={currencyObj.symbolStart}
    symbolEnd={currencyObj.symbolEnd}
    americanFormat={priceFormat === PriceFormats.AMERICAN}
    cellContentDirection="column-reverse"
    max={MAX_VALUES.UNIT_PRICE}
    applySuffixSpacing
  >
    {
      !materialsSection && displayCellContent &&
      <MaterialTitleCellEditor
        title={sectionUnitPriceName || unitPriceName}
        placeholder={t("views.editor.unit_price")}
        onChange={setSectionUnitPriceName}
      />
    }
  </ValueCell>
});

TaskUnitPriceCell.propTypes = {
  element: object.isRequired,
  // actualDepthLevel: number.isRequired,
  displayCellContent: bool,
};
